/* ciw-cache-bust-2026-07-16-poly-half-rim */
/* ciw-cache-bust-2026-07-13-semi-pkg */
/* ciw-cache-bust-2026-07-13-desk-pkg-adv */
(function () {
  var STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)';
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var BODY_ACTIVE_CLASS = 'ciw-la-lens-package-continue-active';
  var pendingWrapper = null;
  var confirming = false;
  var boundScope = null;

  window.ciwLaLensPackageContinue = {
    isActive: function () {
      return document.body.classList.contains(BODY_ACTIVE_CLASS);
    }
  };

  function prefersPolycarbonatePackage() {
    var api = window.ciwLaLensPackageLayout;
    return !!(
      api &&
      typeof api.prefersPolycarbonatePackage === 'function' &&
      api.prefersPolycarbonatePackage()
    );
  }

  function findPolycarbonateWrapper(scope) {
    var api = window.ciwLaLensPackageLayout;
    if (api && typeof api.findPolycarbonatePackageWrapper === 'function') {
      return api.findPolycarbonatePackageWrapper(scope);
    }
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (/^polycarbonate$/i.test(getCardTitle(wrappers[i]))) return wrappers[i];
    }
    return null;
  }

  function getCardTitle(wrapper) {
    var titleNode = wrapper ? wrapper.querySelector('.la-label-title') : null;
    if (!titleNode) return '';
    return titleNode.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
  }

  function isTransitionTypeStepByTitle(scope) {
    if (!scope) return false;
    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3') ||
      scope.querySelector('.la-wrapper-heading');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    return /choose\s+transition\s+type/i.test(title);
  }

  function isTransitionsLensPackageDuplicateStep() {
    var api = window.ciwLaLensThicknessContinue;
    if (!api || typeof api.isAwaitingAddOnsAfterThickness !== 'function') return false;
    return api.isAwaitingAddOnsAfterThickness();
  }

  function getScope() {
    var scope = document.querySelector(STEP_SELECTOR);
    if (!scope) return null;
    if (isTransitionTypeStepByTitle(scope)) return null;
    if (isTransitionsLensPackageDuplicateStep()) return null;
    if (
      window.ciwLaLensColorContinue &&
      typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
      window.ciwLaLensColorContinue.isColorScope(scope)
    ) {
      return null;
    }
    return scope;
  }

  function isActive() {
    return !!(window.ciwLaHostApi && window.ciwLaHostApi.isEyeglass()) && !!getScope();
  }

  function getWrappers(scope) {
    scope = scope || getScope();
    if (!scope) return [];
    return Array.prototype.slice.call(scope.querySelectorAll('.la-label-btn-wrapper'));
  }

  function getCardBtn(wrapper) {
    return wrapper ? wrapper.querySelector('.la-label-btn') : null;
  }

  function getRadio(wrapper) {
    return wrapper ? wrapper.querySelector('input[type="radio"].la-tap-select') : null;
  }

  function findRecommendedWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (
        wrappers[i].classList.contains('recommendation-label-container') ||
        wrappers[i].classList.contains('boxy-recommendation-label-container')
      ) {
        return wrappers[i];
      }
    }
    return null;
  }

  function clearCheckedRadios(scope) {
    getWrappers(scope).forEach(function (wrapper) {
      var radio = getRadio(wrapper);
      if (radio) radio.checked = false;
    });
  }

  function setPicked(wrapper) {
    var scope = getScope();
    if (!scope) return;

    getWrappers(scope).forEach(function (item) {
      var btn = getCardBtn(item);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, item === wrapper);
    });

    pendingWrapper = wrapper || null;
    document.dispatchEvent(new CustomEvent('ciw-la-lens-package:selection-changed'));
  }

  function defaultPick(scope) {
    if (prefersPolycarbonatePackage()) {
      var poly = findPolycarbonateWrapper(scope);
      if (poly) {
        var api = window.ciwLaLensPackageLayout;
        if (api && typeof api.markForcedPackageRecommendation === 'function') {
          api.markForcedPackageRecommendation(poly, scope);
        }
        setPicked(poly);
        return;
      }
    }
    var rec = findRecommendedWrapper(scope);
    if (rec) {
      setPicked(rec);
      return;
    }
    var wrappers = getWrappers(scope);
    if (wrappers.length) setPicked(wrappers[0]);
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest &&
      target.closest('[data-la-tooltip], .tooltip-span, .la-tooltip, .la-help-icon')
    );
  }

  function getWrapperFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function onStepPointerDown(event) {
    if (!isActive() || confirming) return;
    if (isInteractiveTarget(event.target)) return;

    var scope = getScope();
    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
  }

  function onStepClickCapture(event) {
    if (!isActive() || confirming) return;

    var scope = getScope();
    var radio = event.target.closest && event.target.closest('input.la-tap-select');
    if (radio && scope && scope.contains(radio)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      setPicked(radio.closest('.la-label-btn-wrapper'));
      return;
    }

    if (isInteractiveTarget(event.target)) return;

    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
  }

  function confirmSelection() {
    if (!isActive() || confirming) return;

    var radio = getRadio(pendingWrapper);
    var la = window.LensAdvizor;
    if (!radio || !la || typeof la.handleLensChange !== 'function') return;

    confirming = true;
    deactivateStep();

    getWrappers().forEach(function (wrapper) {
      var input = getRadio(wrapper);
      if (input) input.checked = wrapper === pendingWrapper;
    });

    try {
      la.handleLensChange({ target: radio });
    } finally {
      confirming = false;
      pendingWrapper = null;
    }
  }

  function onContinueClick(event) {
    if (!isActive()) return;
    var btn = event.target.closest('.la-prescription-form-btn');
    if (!btn || !btn.closest('.la-prescription-modal-footer')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    confirmSelection();
  }

  function bindScope(scope) {
    if (!scope || boundScope === scope) return;
    unbindScope();
    boundScope = scope;
    scope.addEventListener('pointerdown', onStepPointerDown, true);
    scope.addEventListener('click', onStepClickCapture, true);
  }

  function unbindScope() {
    if (!boundScope) return;
    boundScope.removeEventListener('pointerdown', onStepPointerDown, true);
    boundScope.removeEventListener('click', onStepClickCapture, true);
    boundScope = null;
  }

  function activateStep(scope) {
    scope = scope || getScope();
    if (!scope) return;

    var wasActive = document.body.classList.contains(BODY_ACTIVE_CLASS);
    document.body.classList.add(BODY_ACTIVE_CLASS);
    bindScope(scope);
    clearCheckedRadios(scope);

    if (!wasActive || !pendingWrapper || !scope.contains(pendingWrapper)) {
      defaultPick(scope);
    } else {
      setPicked(pendingWrapper);
    }

    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-package:selection-changed'));
    }, 0);
  }

  function deactivateStep() {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    var cleanupScope = boundScope;
    unbindScope();
    if (!cleanupScope) return;

    getWrappers(cleanupScope).forEach(function (wrapper) {
      var btn = getCardBtn(wrapper);
      if (btn) btn.classList.remove(PICKED_CLASS);
    });
  }

  function scan() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
      deactivateStep();
      return;
    }

    /* GlassesUSA-style: lens-package cards auto-advance on click via LensAdvizor's
       native handler on every viewport. Deactivating removes our click interception. */
    deactivateStep();
    return;

    var scope = getScope();
    if (!scope) {
      deactivateStep();
      return;
    }

    activateStep(scope);
  }

  function scheduleScan() {
    scan();
    window.setTimeout(scan, 0);
    window.setTimeout(scan, 150);
    window.setTimeout(scan, 400);
    window.setTimeout(scan, 850);
    window.setTimeout(scan, 1600);
  }

  document.addEventListener('click', onContinueClick, true);

  document.addEventListener('ciw-la-lens-package:selection-changed', function () {
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-package:continue-sync'));
    }, 0);
  });

  var EVENTS = [
    'LensAdvizor:lens:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered'
  ];

  EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
  });

  document.addEventListener('DOMContentLoaded', scheduleScan);

  document.addEventListener('LensAdvizor:selectLensModal:close', deactivateStep);

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    var packageMoQueued = false;
    new MutationObserver(function () {
      if (packageMoQueued) return;
      packageMoQueued = true;
      window.requestAnimationFrame(function () {
        packageMoQueued = false;
        scheduleScan();
      });
    }).observe(modal, {
      childList: true,
      subtree: true
    });
  }
})();

/* ciw-la-lens-thickness-continue.js — merged into package-continue for CDN delivery */
(function () {
  var STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-options';
  var LENS_GROUP_STEP_SELECTOR = '.la-choose-prescription-wrapper.la-render-lenses.x-pro';
  var SCOPE_CLASS = 'ciw-la-lens-thickness-step';
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var BODY_ACTIVE_CLASS = 'ciw-la-lens-thickness-continue-active';
  var pendingWrapper = null;
  var confirming = false;
  var boundScope = null;
  var lastConfirmedTierName = null;
  var skipDuplicateLensPackage = false;
  var confirmedThicknessScope = null;
  var transitionsAwaitingAddOns = false;
  var skipDuplicateAttempts = 0;
  var MAX_SKIP_DUPLICATE_ATTEMPTS = 12;

  window.ciwLaLensThicknessContinue = {
    isActive: function () {
      return document.body.classList.contains(BODY_ACTIVE_CLASS);
    },
    isTransitionsFlow: function () {
      return isTransitionsLensFlow();
    },
    getLastConfirmedTierName: function () {
      return lastConfirmedTierName;
    },
    isAwaitingAddOnsAfterThickness: function () {
      return transitionsAwaitingAddOns && isTransitionsLensFlow();
    }
  };

  function isLikelyThicknessTierName(name) {
    return /^(basic|standard|polycarbonate|premium|supreme\+?)$/i.test(
      String(name || '')
        .replace(/\s+/g, ' ')
        .trim()
        .split(' - ')[0]
    );
  }

  function isLikelyLensColorCardName(name) {
    var label = String(name || '')
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
    if (!label || isLikelyThicknessTierName(label)) return false;
    return /^(gray|grey|brown|green|graphite|amber|amethyst|ruby|sapphire|emerald|g[\s.-]?15|style\s*colors?)/i.test(
      label
    );
  }

  function isLensColorOptionTitle(title) {
    var label = String(title || '')
      .replace(/\s+/g, ' ')
      .trim();
    return (
      /select\s+choose\s+color\s+for\s+photo\s*c?r?omic/i.test(label) ||
      /choose\s+color\s+for\s+photo\s*c?r?omic/i.test(label) ||
      /select\s+choose\s+color/i.test(label) ||
      /select\s+transition\s+color\s+for\s+transitions\s+gen\s*s/i.test(label) ||
      /select\s+transition\s+color/i.test(label) ||
      /select\s+transition\s+x\s*tract?ive\s+color\s+for\s+transitions\s+xtr\s*active/i.test(label) ||
      /select\s+transition\s+x\s*tract?ive\s+color/i.test(label) ||
      /(?:photo\s*c?r?omic|transitions?\s+gen\s*s|transitions?\s+xtr\s*active|xtractive).+\bcolor\b|\bcolor\b.+(?:photo\s*c?r?omic|transitions?\s+gen\s*s|xtr\s*active|xtractive)/i.test(
        label
      ) ||
      /transition\s*color|lens\s*color|photochromic\s*color|xtr\s*active\s*color|xtractive\s*color|^color$/i.test(
        label
      )
    );
  }

  function isNonTransitionsLensGroupTitle(title) {
    return /^(clear|blue\s*light|sunglass(?:es)?|polarized|non[\s-]?polarized)\b/i.test(
      String(title || '')
        .replace(/\s+/g, ' ')
        .trim()
    );
  }

  function isTransitionsGroupTitle(title) {
    var label = String(title || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!label || isNonTransitionsLensGroupTitle(label)) return false;
    return /\btransitions?\b|photochromic|xtr\s*active|xtractive/i.test(label);
  }

  function isTransitionsLensFlowFromLensAdvizor(la) {
    la = la || window.LensAdvizor;
    if (!la || !la.response) return false;

    if (la.lensGroups && la.response.lensGroupSelected) {
      var selectedKey = la.response.lensGroupSelected;
      var i;
      for (i = 0; i < la.lensGroups.length; i++) {
        var group = la.lensGroups[i];
        if (group.group_type !== selectedKey && String(group.id) !== String(selectedKey)) {
          continue;
        }
        if (isTransitionsGroupTitle(group.group_title || group.title || '')) {
          return true;
        }
      }
    }

    var lens = la.response.lens;
    if (lens) {
      var groupTitle = String(lens.group_title || '')
        .replace(/\s+/g, ' ')
        .trim();
      var groupType = String(lens.group_type || '')
        .replace(/\s+/g, ' ')
        .trim();
      if (
        /transition|photochromic|xtr\s*active|xtractive/i.test(groupTitle) ||
        /transition|photochromic|xtr\s*active|xtractive/i.test(groupType)
      ) {
        return true;
      }
    }

    return false;
  }

  function isTransitionsLensFlowFromDom() {
    var groupStep = document.querySelector(LENS_GROUP_STEP_SELECTOR);
    if (!groupStep) return false;

    var checked = groupStep.querySelector('input[type="radio"].la-tap-select:checked');
    if (!checked) return false;

    var btn = checked.closest('.la-label-btn');
    var titleNode = btn && btn.querySelector('.la-label-title');
    var label = titleNode ? titleNode.textContent : checked.value || '';
    return isTransitionsGroupTitle(label);
  }

  function isTransitionsLensFlow(la) {
    return isTransitionsLensFlowFromLensAdvizor(la) || isTransitionsLensFlowFromDom();
  }

  function getSelectedUsageLabel() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      if (selected && selected.title) {
        if (la.Translation && typeof la.Translation.getTranslatedText === 'function') {
          try {
            var translated = la.Translation.getTranslatedText(selected.title);
            if (translated) {
              return String(translated).replace(/\s+/g, ' ').trim();
            }
          } catch (err) {
            /* fall through */
          }
        }
        if (typeof selected.title === 'string') {
          return selected.title.replace(/\s+/g, ' ').trim();
        }
      }
    }

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return '';

    var usageWrapper = modal.querySelector(
      '.la-choose-prescription-wrapper:not(.la-render-lenses):not(.la-render-options):not(.la-render-review):not(.la-render-addons)'
    );
    if (!usageWrapper) return '';

    var checked = usageWrapper.querySelector('input[type="radio"]:checked');
    if (!checked) return '';

    var btn = checked.closest('.la-label-btn, label.la-label-btn, label');
    var titleEl = btn && btn.querySelector('.la-label-title');
    return titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function isNonPrescriptionFlow() {
    var la = window.LensAdvizor;
    if (la && la.response && la.response.selectedPrescriptionType) {
      var selected = la.response.selectedPrescriptionType;
      var text = '';
      if (typeof selected === 'string') {
        text = selected;
      } else if (selected) {
        text = [selected.title, selected.name, selected.type, selected.handle]
          .filter(Boolean)
          .join(' ');
      }
      if (/non[\s-]?prescription|fashion|plano/i.test(text)) return true;
    }
    return /non[\s-]?prescription|fashion|plano/i.test(getSelectedUsageLabel());
  }

  function isCombinedColorAndThicknessScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;
    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var tierCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }
    return colorCount >= 1 && tierCount >= 2;
  }

  function isNonPrescriptionCombinedScope(scope) {
    return (
      isTransitionsLensFlow() &&
      isNonPrescriptionFlow() &&
      isCombinedColorAndThicknessScope(scope)
    );
  }

  function isCombinedThicknessPhase(scope) {
    if (!isNonPrescriptionCombinedScope(scope)) return false;
    var api = window.ciwLaLensColorContinue;
    return !!(
      api &&
      typeof api.isCombinedColorConfirmed === 'function' &&
      api.isCombinedColorConfirmed()
    );
  }

  function isTierCardWrapper(wrapper) {
    if (!wrapper) return false;
    var titleNode = wrapper.querySelector('.la-label-title');
    var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
    return isLikelyThicknessTierName(cardTitle);
  }

  function isThicknessOptionScope(scope) {
    if (!scope || !scope.classList.contains('la-render-options')) return false;

    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (/lens\s*thickness|lens\s*material|^material$/i.test(title)) return true;
    if (isLensColorOptionTitle(title)) return false;

    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    if (!wrappers.length) return false;

    var tierCount = 0;
    var colorCount = 0;
    var i;
    for (i = 0; i < wrappers.length; i++) {
      var titleNode = wrappers[i].querySelector('.la-label-title');
      var cardTitle = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '';
      if (isLikelyThicknessTierName(cardTitle)) tierCount++;
      else if (isLikelyLensColorCardName(cardTitle)) colorCount++;
    }

    if (colorCount >= 1 && tierCount < 2) return false;

    if (/choose\s*lens\s*package/i.test(title)) return tierCount >= 2;
    return tierCount >= 2;
  }

  function getScope() {
    if (!isTransitionsLensFlow()) return null;
    if (transitionsAwaitingAddOns) return null;

    var scopes = document.querySelectorAll(STEP_SELECTOR);
    var fallback = null;
    var i;
    for (i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      if (
        isNonPrescriptionCombinedScope(scope) &&
        !isCombinedThicknessPhase(scope)
      ) {
        continue;
      }
      if (
        window.ciwLaLensColorContinue &&
        typeof window.ciwLaLensColorContinue.isColorScope === 'function' &&
        window.ciwLaLensColorContinue.isColorScope(scope)
      ) {
        continue;
      }
      if (!isThicknessOptionScope(scope)) continue;
      if (scope === confirmedThicknessScope) continue;
      if (!fallback) fallback = scope;
      if (isScopeVisible(scope)) return scope;
    }

    return fallback && isScopeVisible(fallback) ? fallback : null;
  }

  function isActive() {
    return !!(window.ciwLaHostApi && window.ciwLaHostApi.isEyeglass()) && !!getScope();
  }

  function getWrappers(scope) {
    scope = scope || getScope();
    if (!scope) return [];
    var wrappers = Array.prototype.slice.call(
      scope.querySelectorAll('.la-label-btn-wrapper')
    );
    if (isCombinedThicknessPhase(scope)) {
      return wrappers.filter(isTierCardWrapper);
    }
    return wrappers;
  }

  function getCardBtn(wrapper) {
    return wrapper ? wrapper.querySelector('.la-label-btn') : null;
  }

  function getRadio(wrapper) {
    return wrapper ? wrapper.querySelector('input[type="radio"].la-tap-select') : null;
  }

  function getCardTitle(wrapper) {
    var titleNode = wrapper ? wrapper.querySelector('.la-label-title') : null;
    if (!titleNode) return '';
    return titleNode.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
  }

  function isStandardTierName(name) {
    return /^standard$/i.test(String(name || '').replace(/\s+/g, ' ').trim());
  }

  function findStandardWrapper(scope) {
    var wrappers = getWrappers(scope);
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (isStandardTierName(getCardTitle(wrappers[i]))) {
        return wrappers[i];
      }
    }
    return null;
  }

  function findRecommendedWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (
        wrappers[i].classList.contains('recommendation-label-container') ||
        wrappers[i].classList.contains('boxy-recommendation-label-container')
      ) {
        return wrappers[i];
      }
    }
    return null;
  }

  function prefersPolycarbonatePackage() {
    var api = window.ciwLaLensPackageLayout;
    return !!(
      api &&
      typeof api.prefersPolycarbonatePackage === 'function' &&
      api.prefersPolycarbonatePackage()
    );
  }

  function findPolycarbonateWrapper(scope) {
    var api = window.ciwLaLensPackageLayout;
    if (api && typeof api.findPolycarbonatePackageWrapper === 'function') {
      return api.findPolycarbonatePackageWrapper(scope);
    }
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (/^polycarbonate$/i.test(getCardTitle(wrappers[i]))) return wrappers[i];
    }
    return null;
  }

  function clearCheckedRadios(scope) {
    getWrappers(scope).forEach(function (wrapper) {
      var radio = getRadio(wrapper);
      if (radio) radio.checked = false;
    });
  }

  function setPicked(wrapper) {
    var scope = getScope();
    if (!scope) return;

    getWrappers(scope).forEach(function (item) {
      var btn = getCardBtn(item);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, item === wrapper);
    });

    pendingWrapper = wrapper || null;
    document.dispatchEvent(new CustomEvent('ciw-la-lens-thickness:selection-changed'));
  }

  function defaultPick(scope) {
    if (prefersPolycarbonatePackage()) {
      var poly = findPolycarbonateWrapper(scope);
      if (poly) {
        var api = window.ciwLaLensPackageLayout;
        if (api && typeof api.markForcedPackageRecommendation === 'function') {
          api.markForcedPackageRecommendation(poly, scope);
        }
        setPicked(poly);
        return;
      }
    }
    var standard = findStandardWrapper(scope);
    if (standard) {
      setPicked(standard);
      return;
    }
    var rec = findRecommendedWrapper(scope);
    if (rec) {
      setPicked(rec);
      return;
    }
    var wrappers = getWrappers(scope);
    if (wrappers.length) setPicked(wrappers[0]);
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest &&
      target.closest('[data-la-tooltip], .tooltip-span, .la-tooltip, .la-help-icon')
    );
  }

  function getWrapperFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function onStepPointerDown(event) {
    if (!isActive() || confirming) return;
    if (isInteractiveTarget(event.target)) return;

    var scope = getScope();
    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
  }

  /* GlassesUSA-style: clicking a thickness/package tier confirms immediately
     (auto-advance) on every viewport. */
  function maybeAutoAdvanceOnClick() {
    if (confirming || !pendingWrapper) return;
    confirmSelection();
  }

  function onStepClickCapture(event) {
    if (!isActive() || confirming) return;

    var scope = getScope();
    var radio = event.target.closest && event.target.closest('input.la-tap-select');
    if (radio && scope && scope.contains(radio)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      setPicked(radio.closest('.la-label-btn-wrapper'));
      maybeAutoAdvanceOnClick();
      return;
    }

    if (isInteractiveTarget(event.target)) return;

    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
    maybeAutoAdvanceOnClick();
  }

  function isScopeVisible(scope) {
    if (!scope || scope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(scope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return scope.getClientRects().length > 0;
  }

  function isTransitionTypeLensScope(scope) {
    if (!scope) return false;
    var titleEl =
      scope.querySelector('#la_prescriptionSelect_title') ||
      scope.querySelector('.la-wrapper-heading h3');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    return /choose\s+transition\s+type/i.test(title);
  }

  function findRadioByTierName(scope, tierName) {
    if (!scope || !tierName) return null;
    var normalized = String(tierName).replace(/\s+/g, ' ').trim().toLowerCase();
    var wrappers = scope.querySelectorAll('.la-label-btn-wrapper');
    var i;
    for (i = 0; i < wrappers.length; i++) {
      if (getCardTitle(wrappers[i]).toLowerCase() === normalized) {
        return getRadio(wrappers[i]);
      }
    }
    return null;
  }

  function isAddOnsStepVisible() {
    var addonsScope = document.querySelector('.la-choose-prescription-wrapper.la-render-addons');
    return !!(addonsScope && isScopeVisible(addonsScope));
  }

  function clearTransitionsAwaitingAddOns() {
    transitionsAwaitingAddOns = false;
    skipDuplicateAttempts = 0;
    confirmedThicknessScope = null;
  }

  function submitLensPackageChoice(radio, la) {
    if (!radio || !la) return;

    if (typeof la.handleLensChange === 'function') {
      la.handleLensChange({ target: radio });
    }

    var lensesForm =
      document.querySelector('#la-prescription-form[data-form="lenses"]') ||
      (radio.closest && radio.closest('#la-prescription-form')) ||
      document.querySelector('#la-prescription-form');

    if (lensesForm && typeof la.handleFormSubmit === 'function') {
      la.handleFormSubmit({
        target: lensesForm,
        preventDefault: function () {},
        stopImmediatePropagation: function () {}
      });
    }
  }

  function submitThicknessChoice(radio, la) {
    if (!radio || !la) return;

    // Thickness is the last intermediate option step — same API as color.
    if (typeof la.handleSingleOptionChange === 'function') {
      la.handleSingleOptionChange({ target: radio });
      return;
    }

    if (typeof la.handleOptionChange === 'function') {
      la.handleOptionChange({ target: radio, type: 'click' });
    }

    var form = document.querySelector('#la-prescription-form[data-form="options"]');
    if (form && typeof la.handleFormSubmit === 'function') {
      la.handleFormSubmit({
        target: form,
        preventDefault: function () {},
        stopImmediatePropagation: function () {}
      });
    } else if (form) {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  }

  function trySkipTransitionsDuplicateLensPackageStep() {
    if (!transitionsAwaitingAddOns || skipDuplicateLensPackage) return false;

    if (isAddOnsStepVisible()) {
      clearTransitionsAwaitingAddOns();
      return true;
    }

    if (skipDuplicateAttempts >= MAX_SKIP_DUPLICATE_ATTEMPTS) {
      clearTransitionsAwaitingAddOns();
      return false;
    }

    skipDuplicateAttempts += 1;

    if (!isTransitionsLensFlow()) return false;

    var la = window.LensAdvizor;
    if (!la) return false;

    var lensScope = document.querySelector('.la-choose-prescription-wrapper.la-render-lenses:not(.x-pro)');
    if (lensScope && isScopeVisible(lensScope) && !isTransitionTypeLensScope(lensScope)) {
      var lensRadio =
        findRadioByTierName(lensScope, lastConfirmedTierName) ||
        lensScope.querySelector('input[type="radio"].la-tap-select:checked') ||
        lensScope.querySelector('input[type="radio"].la-tap-select');
      if (!lensRadio) return false;

      skipDuplicateLensPackage = true;
      try {
        lensScope.querySelectorAll('input[type="radio"].la-tap-select').forEach(function (input) {
          input.checked = input === lensRadio;
        });
        submitLensPackageChoice(lensRadio, la);
        return true;
      } finally {
        window.setTimeout(function () {
          skipDuplicateLensPackage = false;
          if (isAddOnsStepVisible()) {
            clearTransitionsAwaitingAddOns();
          } else {
            scheduleSkipTransitionsDuplicateLensPackage();
          }
        }, 250);
      }
    }

    var optionsScopes = document.querySelectorAll(STEP_SELECTOR);
    var i;
    for (i = 0; i < optionsScopes.length; i++) {
      var optionsScope = optionsScopes[i];
      if (!isScopeVisible(optionsScope)) continue;
      if (optionsScope === confirmedThicknessScope) continue;
      if (!isThicknessOptionScope(optionsScope)) continue;

      var optionsRadio =
        findRadioByTierName(optionsScope, lastConfirmedTierName) ||
        optionsScope.querySelector('input[type="radio"].la-tap-select:checked') ||
        optionsScope.querySelector('input[type="radio"].la-tap-select');
      if (!optionsRadio) continue;

      skipDuplicateLensPackage = true;
      try {
        optionsScope.querySelectorAll('input[type="radio"].la-tap-select').forEach(function (input) {
          input.checked = input === optionsRadio;
        });
        submitThicknessChoice(optionsRadio, la);
        return true;
      } finally {
        window.setTimeout(function () {
          skipDuplicateLensPackage = false;
          scheduleSkipTransitionsDuplicateLensPackage();
        }, 250);
      }
    }

    return false;
  }

  function scheduleSkipTransitionsDuplicateLensPackage() {
    if (!transitionsAwaitingAddOns) return;
    [0, 80, 200, 450, 900, 1600, 2600, 4000].forEach(function (delay) {
      window.setTimeout(trySkipTransitionsDuplicateLensPackageStep, delay);
    });
  }

  function confirmSelection() {
    if (!isActive() || confirming) return;

    var scope = getScope();
    var radio = getRadio(pendingWrapper);
    var la = window.LensAdvizor;
    if (!scope || !radio || !la) return;

    confirming = true;
    lastConfirmedTierName = pendingWrapper ? getCardTitle(pendingWrapper) : null;
    confirmedThicknessScope = scope;
    transitionsAwaitingAddOns = true;
    skipDuplicateAttempts = 0;
    deactivateStep();

    getWrappers(scope).forEach(function (wrapper) {
      var input = getRadio(wrapper);
      if (input) input.checked = wrapper === pendingWrapper;
    });

    try {
      submitThicknessChoice(radio, la);
      scheduleSkipTransitionsDuplicateLensPackage();
    } finally {
      confirming = false;
      pendingWrapper = null;
    }
  }

  function onContinueClick(event) {
    if (!isActive()) return;
    var btn = event.target.closest('.la-prescription-form-btn');
    if (!btn || !btn.closest('.la-prescription-modal-footer')) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    confirmSelection();
  }

  function bindScope(scope) {
    if (!scope || boundScope === scope) return;
    unbindScope();
    boundScope = scope;
    scope.classList.add(SCOPE_CLASS);
    scope.addEventListener('pointerdown', onStepPointerDown, true);
    scope.addEventListener('click', onStepClickCapture, true);
  }

  function unbindScope() {
    if (!boundScope) return;
    boundScope.classList.remove(SCOPE_CLASS);
    boundScope.removeEventListener('pointerdown', onStepPointerDown, true);
    boundScope.removeEventListener('click', onStepClickCapture, true);
    boundScope = null;
  }

  function activateStep(scope) {
    scope = scope || getScope();
    if (!scope) return;

    var wasActive = document.body.classList.contains(BODY_ACTIVE_CLASS);
    document.body.classList.add(BODY_ACTIVE_CLASS);
    bindScope(scope);
    clearCheckedRadios(scope);

    if (!wasActive || !pendingWrapper || !scope.contains(pendingWrapper)) {
      defaultPick(scope);
    } else {
      setPicked(pendingWrapper);
    }

    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-thickness:selection-changed'));
    }, 0);
  }

  function deactivateStep() {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    var cleanupScope = boundScope;
    unbindScope();
    if (!cleanupScope) return;

    getWrappers(cleanupScope).forEach(function (wrapper) {
      var btn = getCardBtn(wrapper);
      if (btn) btn.classList.remove(PICKED_CLASS);
    });
  }

  function scan() {
    if (!window.ciwLaHostApi || !window.ciwLaHostApi.isEyeglass()) {
      deactivateStep();
      return;
    }

    if (!isTransitionsLensFlow()) {
      clearTransitionsAwaitingAddOns();
    }

    var scope = getScope();
    if (!scope) {
      deactivateStep();
      document.querySelectorAll('.' + SCOPE_CLASS).forEach(function (el) {
        el.classList.remove(SCOPE_CLASS);
      });
      return;
    }

    activateStep(scope);
  }

  function scheduleScan() {
    scan();
    window.setTimeout(scan, 0);
    window.setTimeout(scan, 150);
    window.setTimeout(scan, 400);
    window.setTimeout(scan, 850);
    window.setTimeout(scan, 1600);
  }

  document.addEventListener('click', onContinueClick, true);

  document.addEventListener('ciw-la-lens-thickness:selection-changed', function () {
    window.setTimeout(function () {
      document.dispatchEvent(new CustomEvent('ciw-la-lens-thickness:continue-sync'));
    }, 0);
  });

  var EVENTS = [
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:lens:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered',
    'LensAdvizor:addOns:rendered'
  ];

  EVENTS.forEach(function (eventName) {
    document.addEventListener(eventName, scheduleScan);
    document.addEventListener(eventName, function () {
      if (isAddOnsStepVisible()) clearTransitionsAwaitingAddOns();
      scheduleSkipTransitionsDuplicateLensPackage();
    });
  });

  document.addEventListener('ciw-la-lens-color:combined-phase-b', scheduleScan);

  document.addEventListener('DOMContentLoaded', scheduleScan);
  document.addEventListener('DOMContentLoaded', scheduleSkipTransitionsDuplicateLensPackage);

  document.addEventListener('LensAdvizor:selectLensModal:close', function () {
    deactivateStep();
    lastConfirmedTierName = null;
    skipDuplicateLensPackage = false;
    clearTransitionsAwaitingAddOns();
  });

  var modal = document.getElementById('lensadvizor-prescription-modal');
  if (modal) {
    var thicknessMoQueued = false;
    new MutationObserver(function () {
      if (thicknessMoQueued) return;
      thicknessMoQueued = true;
      window.requestAnimationFrame(function () {
        thicknessMoQueued = false;
        scheduleScan();
        scheduleSkipTransitionsDuplicateLensPackage();
      });
    }).observe(modal, {
      childList: true,
      subtree: true
    });
  }
})();

/* ciw-la-progressive-type-continue.js — Progressive + Transitions "Choose progressive type"
   (Ultimate HD / Varilux / ZEISS): native LensAdvizor tap-to-advance on all viewports.
   No custom intercept, no footer Continue — card click goes to the next step. */
(function () {
  var BODY_ACTIVE_CLASS = 'ciw-la-progressive-type-active';

  function cleanup() {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
  }

  window.ciwLaProgressiveTypeContinue = {
    isActive: function () {
      return false;
    },
    hasSelection: function () {
      return false;
    },
    confirm: function () {}
  };

  document.addEventListener('LensAdvizor:selectLensModal:close', cleanup);
})();

/* ciw-la-progressive-package-continue.js
   Sunglasses "Choose lens package" (.la-render-options.ciw-la-lens-package-step)
   uses a combined color+tier form. Native LA click does not reliably advance, so
   we intercept tier taps on BOTH mobile and desktop and submit via
   submitPackageChoice (same bridge that works on mobile). */
(function () {
  var SCOPE_SELECTOR =
    '.la-choose-prescription-wrapper.la-render-options.ciw-la-lens-package-step';
  var PICKED_CLASS = 'ciw-la-lens-card--picked';
  var BODY_ACTIVE_CLASS = 'ciw-la-progressive-package-active';
  var BODY_VISITED_CLASS = 'ciw-la-sunglasses-package-visited';
  var pendingWrapper = null;
  var recommendedWrapper = null;
  var confirming = false;
  var boundScope = null;
  var outlineTarget = null;
  var scanQueued = false;
  var confirmUnlockTimer = null;
  var outlineSyncTimer = null;

  function isScopeVisible(scope) {
    if (!scope || scope.hasAttribute('hidden')) return false;
    var style = window.getComputedStyle(scope);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    return scope.getClientRects().length > 0;
  }

  function isSunglassesPackageStep(scope) {
    var titleEl =
      document.querySelector(
        '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
      ) || null;
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!/choose\s+lens\s+package/i.test(title)) return false;
    if (!(scope && scope.classList.contains('la-render-options'))) return false;

    if (
      document.body.classList.contains('ciw-la-sunglasses-post-confirm') ||
      document.body.classList.contains('ciw-la-sunglasses-package-revealed') ||
      document.body.classList.contains(BODY_VISITED_CLASS)
    ) {
      return true;
    }

    /* Progressive clears post-confirm on the progressive-type step, then LA
       advances to package. Still treat tinted Solid/Gradient/Polarized as the
       sunglasses package step so Continue can bridge Available Upgrades. */
    var la = window.LensAdvizor;
    var lensName = la && la.response && la.response.lens && la.response.lens.name;
    return /solid tint|gradient tint|polarized/i.test(String(lensName || ''));
  }

  function findSunglassesPackageScope() {
    var scope = document.querySelector(SCOPE_SELECTOR);
    if (scope && isScopeVisible(scope)) return scope;

    var modal = document.getElementById('lensadvizor-prescription-modal');
    if (!modal) return null;

    var scopes = modal.querySelectorAll('.la-choose-prescription-wrapper.la-render-options');
    var i;
    for (i = 0; i < scopes.length; i++) {
      if (!isScopeVisible(scopes[i])) continue;
      if (!isSunglassesPackageStep(scopes[i])) continue;
      if (getWrappers(scopes[i]).length >= 2) {
        scopes[i].classList.add('ciw-la-lens-package-step');
        return scopes[i];
      }
    }

    return null;
  }

  function getScope() {
    if (!(window.ciwLaHostApi && window.ciwLaHostApi.isEyeglass())) return null;

    if (
      window.ciwLaLensThicknessContinue &&
      typeof window.ciwLaLensThicknessContinue.isActive === 'function' &&
      window.ciwLaLensThicknessContinue.isActive()
    ) {
      return null;
    }

    return findSunglassesPackageScope();
  }

  function isProgressivePackageActionButton(btn) {
    if (!btn || !btn.closest) return false;
    return !!(
      btn.closest('.la-prescription-modal-footer') ||
      btn.closest('.ciw-la-subtotal-footer') ||
      btn.closest('.la-subtotal-footer-button') ||
      btn.closest('.la-prescription-modal-content-body') ||
      btn.closest('.ciw-la-desktop-action-button')
    );
  }

  window.ciwLaProgressivePackageContinue = {
    isActive: function () {
      return document.body.classList.contains(BODY_ACTIVE_CLASS);
    },
    hasSelection: function () {
      return !!pendingWrapper;
    },
    confirm: confirmSelection
  };

  function isActive() {
    return !!getScope();
  }

  function isTierPackageWrapper(wrapper) {
    if (!wrapper) return false;
    if (wrapper.classList.contains('ciw-la-sunglasses-outgoing-color-card')) return false;
    return /^(basic|standard|polycarbonate|premium|supreme\+?)$/i.test(getCardTitle(wrapper));
  }

  function getWrappers(scope) {
    scope = scope || getScope();
    if (!scope) return [];
    return Array.prototype.slice
      .call(scope.querySelectorAll('.la-label-btn-wrapper'))
      .filter(isTierPackageWrapper);
  }

  function getCardBtn(wrapper) {
    return wrapper ? wrapper.querySelector('.la-label-btn') : null;
  }

  function getRadio(wrapper) {
    return wrapper ? wrapper.querySelector('input[type="radio"].la-tap-select') : null;
  }

  function getCardTitle(wrapper) {
    var titleNode = wrapper ? wrapper.querySelector('.la-label-title') : null;
    if (!titleNode) return '';
    return titleNode.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .split(' - ')[0];
  }

  function findStandardWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (/^standard$/i.test(getCardTitle(wrappers[i]))) return wrappers[i];
    }
    return null;
  }

  function findPolycarbonateWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (/^polycarbonate$/i.test(getCardTitle(wrappers[i]))) return wrappers[i];
    }
    return null;
  }

  function findRecommendedWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      if (
        wrappers[i].classList.contains('recommendation-label-container') ||
        wrappers[i].classList.contains('boxy-recommendation-label-container')
      ) {
        return wrappers[i];
      }
    }
    return null;
  }

  function getCheckedWrapper(scope) {
    var wrappers = getWrappers(scope);
    for (var i = 0; i < wrappers.length; i++) {
      var radio = getRadio(wrappers[i]);
      if (radio && radio.checked) return wrappers[i];
    }
    return null;
  }

  function prefersPolycarbonatePackage() {
    var api = window.ciwLaLensPackageLayout;
    return !!(
      api &&
      typeof api.prefersPolycarbonatePackage === 'function' &&
      api.prefersPolycarbonatePackage()
    );
  }

  function getRecommendedWrapper(scope) {
    if (prefersPolycarbonatePackage()) {
      return (
        findPolycarbonateWrapper(scope) ||
        findRecommendedWrapper(scope) ||
        findStandardWrapper(scope) ||
        getCheckedWrapper(scope) ||
        getWrappers(scope)[0] ||
        null
      );
    }
    return (
      findStandardWrapper(scope) ||
      findRecommendedWrapper(scope) ||
      findPolycarbonateWrapper(scope) ||
      getCheckedWrapper(scope) ||
      getWrappers(scope)[0] ||
      null
    );
  }

  function isDefaultBasicOnly(scope) {
    var checked = getCheckedWrapper(scope);
    if (!checked) return false;
    if (!/^basic$/i.test(getCardTitle(checked))) return false;
    return !document.body.classList.contains(BODY_VISITED_CLASS);
  }

  function applyStandardRecommendation(scope) {
    var standard = getRecommendedWrapper(scope);
    if (!standard) return;

    var standardBtn = getCardBtn(standard);
    var standardRadio = getRadio(standard);
    if (
      standardBtn &&
      standardBtn.classList.contains(PICKED_CLASS) &&
      standardRadio &&
      standardRadio.checked &&
      !pendingWrapper
    ) {
      if (prefersPolycarbonatePackage() && /^polycarbonate$/i.test(getCardTitle(standard))) {
        var apiEarly = window.ciwLaLensPackageLayout;
        if (apiEarly && typeof apiEarly.markForcedPackageRecommendation === 'function') {
          apiEarly.markForcedPackageRecommendation(standard, scope);
        }
      }
      return;
    }

    getWrappers(scope).forEach(function (wrapper) {
      var radio = getRadio(wrapper);
      if (!radio) return;
      radio.checked = wrapper === standard;
    });
    paintOutline(scope, standard);
    if (prefersPolycarbonatePackage() && /^polycarbonate$/i.test(getCardTitle(standard))) {
      var api = window.ciwLaLensPackageLayout;
      if (api && typeof api.markForcedPackageRecommendation === 'function') {
        api.markForcedPackageRecommendation(standard, scope);
      }
    }
    pendingWrapper = null;
  }

  /* Outline a card without committing it (pure visual recommendation). */
  function paintOutline(scope, wrapper) {
    getWrappers(scope).forEach(function (item) {
      var btn = getCardBtn(item);
      if (!btn) return;
      btn.classList.toggle(PICKED_CLASS, item === wrapper);
    });
    outlineTarget = wrapper || null;
  }

  function clearOutlines(scope) {
    scope = scope || boundScope || getScope();
    if (!scope) return;
    getWrappers(scope).forEach(function (wrapper) {
      var btn = getCardBtn(wrapper);
      if (btn) btn.classList.remove(PICKED_CLASS);
    });
    outlineTarget = null;
  }

  function resolveOutlineTarget(scope) {
    if (pendingWrapper && scope.contains(pendingWrapper)) return pendingWrapper;

    var checked = getCheckedWrapper(scope);
    if (checked && !isDefaultBasicOnly(scope)) return checked;

    if (outlineTarget && scope.contains(outlineTarget)) return outlineTarget;

    return getRecommendedWrapper(scope);
  }

  function ensureStableOutline(scope) {
    scope = scope || getScope();
    if (!scope) return;

    var target = resolveOutlineTarget(scope);
    if (!target) return;

    var btn = getCardBtn(target);
    if (btn && btn.classList.contains(PICKED_CLASS)) {
      outlineTarget = target;
      return;
    }

    paintOutline(scope, target);
  }

  function scheduleOutlineSync(scope) {
    if (outlineSyncTimer) window.clearTimeout(outlineSyncTimer);
    outlineSyncTimer = window.setTimeout(function () {
      outlineSyncTimer = null;
      if (confirming) return;
      ensureStableOutline(scope || getScope());
    }, 0);
  }

  /* A real customer tap: outline the card AND mark it as the pending selection
     that "Save and Continue" will commit. */
  function setPicked(wrapper) {
    var scope = getScope();
    if (!scope || !isTierPackageWrapper(wrapper)) return;
    if (pendingWrapper === wrapper) {
      paintOutline(scope, wrapper);
      return;
    }
    paintOutline(scope, wrapper);
    pendingWrapper = wrapper || null;
  }

  function isInteractiveTarget(target) {
    return !!(
      target &&
      target.closest &&
      target.closest('[data-la-tooltip], .tooltip-span, .la-tooltip, .la-help-icon')
    );
  }

  function getWrapperFromEventTarget(target) {
    if (!target || !target.closest) return null;
    var btn = target.closest('.la-label-btn');
    if (!btn) return null;
    return btn.closest('.la-label-btn-wrapper');
  }

  function onStepPointerDown(event) {
    if (!isActive() || confirming) return;
    if (isInteractiveTarget(event.target)) return;

    var scope = getScope();
    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper) || !isTierPackageWrapper(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
    /* pointerdown preventDefault can swallow the later click on mobile — advance here. */
    maybeAutoAdvanceOnClick();
  }

  function onStepClickCapture(event) {
    if (!isActive() || confirming) return;

    var scope = getScope();
    var radio = event.target.closest && event.target.closest('input.la-tap-select');
    if (radio && scope && scope.contains(radio)) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      setPicked(radio.closest('.la-label-btn-wrapper'));
      maybeAutoAdvanceOnClick();
      return;
    }

    if (isInteractiveTarget(event.target)) return;

    var wrapper = getWrapperFromEventTarget(event.target);
    if (!wrapper || !scope.contains(wrapper) || !isTierPackageWrapper(wrapper)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    setPicked(wrapper);
    maybeAutoAdvanceOnClick();
  }

  function isAddOnsStepVisible() {
    var addonsScope = document.querySelector('.la-choose-prescription-wrapper.la-render-addons');
    return !!(addonsScope && isScopeVisible(addonsScope));
  }

  function shouldBridgeSunglassesUpgrades() {
    if (
      document.body.classList.contains('ciw-la-sunglasses-post-confirm') ||
      document.body.classList.contains('ciw-la-sunglasses-package-revealed') ||
      document.body.classList.contains(BODY_VISITED_CLASS)
    ) {
      return true;
    }

    var titleEl = document.querySelector(
      '#lensadvizor-prescription-modal #la_prescriptionSelect_title, #lensadvizor-prescription-modal .la-wrapper-heading h3'
    );
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!/choose\s+lens\s+package/i.test(title)) return false;

    var la = window.LensAdvizor;
    var lensName = la && la.response && la.response.lens && la.response.lens.name;
    return /solid tint|gradient tint|polarized/i.test(String(lensName || ''));
  }

  function suppressLaAdvanceAfterBridge(la, ms) {
    if (!la || la.__ciwLaSgBridgeGuard) return;
    if (typeof la.renderReview !== 'function') return;

    /* Only block the race that jumps package → Review. Do NOT wrap
       handleFormSubmit / handleOptionChange — those power Available Upgrades
       taps + Continue. Re-calling renderAddOns() here also wiped selections. */
    la.__ciwLaSgBridgeGuard = true;
    var until = Date.now() + (ms || 1200);
    var original = la.renderReview;

    function addonsStepIsVisible() {
      var addons = document.querySelector('.la-choose-prescription-wrapper.la-render-addons');
      if (!addons || addons.hasAttribute('hidden')) return false;
      var style = window.getComputedStyle(addons);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return addons.getClientRects().length > 0;
    }

    function release() {
      if (!la.__ciwLaSgBridgeGuard) return;
      la.renderReview = original;
      la.__ciwLaSgBridgeGuard = false;
      if (releaseTimer) {
        window.clearTimeout(releaseTimer);
        releaseTimer = null;
      }
    }

    la.renderReview = function () {
      if (Date.now() < until && document.body.classList.contains('ciw-la-sunglasses-bridged-upgrades')) {
        if (addonsStepIsVisible()) return;
      }
      return original.apply(la, arguments);
    };

    var releaseTimer = window.setTimeout(release, (ms || 1200) + 50);

    /* Release as soon as the customer can use Upgrades (selection / Continue). */
    window.setTimeout(function () {
      if (addonsStepIsVisible()) release();
    }, 120);
  }

  function submitPackageChoice(radio) {
    var la = window.LensAdvizor;
    if (!radio || !la) return;

    /* Non-Rx often keeps tint color + package in #la-prescription-form[data-form="options"].
       Distance/Reading/Progressive/Bifocal sunglasses package usually has NO that form —
       radios live on the cards only. */
    var form = document.querySelector('#la-prescription-form[data-form="options"]');
    var bridge = window.ciwLaNonRxUpgradesBridge;

    radio.checked = true;

    if (form) {
      var colorRadio =
        form.querySelector('input[name="radio-carousel-option1"]:checked') ||
        form.querySelector('input[name="radio-carousel-option1"]');

      if (colorRadio && typeof la.handleSingleOptionChange === 'function') {
        la.handleSingleOptionChange({ target: colorRadio });
      }

      if (typeof la.handleSingleOptionChange === 'function') {
        la.handleSingleOptionChange({ target: radio });
      }
    }

    if (bridge && typeof bridge.cacheFromLa === 'function') {
      bridge.cacheFromLa(la);
    }

    if (isAddOnsStepVisible()) {
      return;
    }

    /* Solid tint (all usages) often omits add_ons_products — bridge in the Clear
       coating flow and render Available Upgrades. Do NOT call handleSingleOptionChange
       before the bridge on formless Rx paths: on mobile Bifocal that async-advances
       LA straight to Review and wipes upgrades. */
    if (
      bridge &&
      typeof bridge.tryRenderAddOns === 'function' &&
      shouldBridgeSunglassesUpgrades() &&
      bridge.tryRenderAddOns(la)
    ) {
      suppressLaAdvanceAfterBridge(la, 1200);
      /* Tell addons-continue to ignore the leftover package tap that lands on a coating. */
      document.dispatchEvent(new CustomEvent('ciw-la-addons:arm-ghost-guard'));
      if (!form && typeof la.handleSingleOptionChange === 'function') {
        try {
          la.handleSingleOptionChange({ target: radio });
        } catch (e) {}
      }
      return;
    }

    if (!form && typeof la.handleSingleOptionChange === 'function') {
      la.handleSingleOptionChange({ target: radio });
    }

    if (form && typeof la.handleFormSubmit === 'function') {
      la.handleFormSubmit({
        target: form,
        preventDefault: function () {},
        stopImmediatePropagation: function () {}
      });
      return;
    }

    if (typeof la.handleOptionChange === 'function') {
      la.handleOptionChange({ target: radio, type: 'click' });
    }
  }

  function maybeAutoAdvanceOnClick() {
    if (confirming || !pendingWrapper) return;
    confirmSelection();
  }

  function confirmSelection() {
    if (!isActive() || confirming) return;

    var scope = getScope();
    var radio = getRadio(pendingWrapper);
    var la = window.LensAdvizor;
    if (!scope || !radio || !la) return;

    confirming = true;
    document.body.classList.add(BODY_VISITED_CLASS);
    suspendStep();

    getWrappers(scope).forEach(function (wrapper) {
      var input = getRadio(wrapper);
      if (input) input.checked = wrapper === pendingWrapper;
    });

    try {
      submitPackageChoice(radio);
    } finally {
      if (confirmUnlockTimer) window.clearTimeout(confirmUnlockTimer);
      /* Keep confirming longer after bridge so a trailing mobile click/touch
         cannot re-enter and race LA into Review. */
      var unlockMs = document.body.classList.contains('ciw-la-sunglasses-bridged-upgrades')
        ? 1200
        : 400;
      confirmUnlockTimer = window.setTimeout(function () {
        confirming = false;
        pendingWrapper = null;
        confirmUnlockTimer = null;
      }, unlockMs);
    }
  }

  function onContinueClick(event) {
    if (!isActive() || confirming) return;
    var btn = event.target.closest('.la-prescription-form-btn');
    if (!btn || !isProgressivePackageActionButton(btn)) return;

    /* This module only owns sunglasses package. If they never tapped, use the
       checked/recommended tier so Continue still bridges Available Upgrades
       (Rx sunglasses paths have no options form for native LA submit). */
    if (!pendingWrapper) {
      var scope = getScope();
      pendingWrapper =
        (scope && (getCheckedWrapper(scope) || getRecommendedWrapper(scope))) || null;
      if (!pendingWrapper) return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    confirmSelection();
  }

  function bindScope(scope) {
    if (!scope || boundScope === scope) return;
    unbindScope();
    boundScope = scope;
    scope.addEventListener('pointerdown', onStepPointerDown, true);
    scope.addEventListener('click', onStepClickCapture, true);
  }

  function unbindScope() {
    if (!boundScope) return;
    boundScope.removeEventListener('pointerdown', onStepPointerDown, true);
    boundScope.removeEventListener('click', onStepClickCapture, true);
    boundScope = null;
  }

  function suspendStep() {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    unbindScope();
  }

  function deactivateStep(clearOutline) {
    document.body.classList.remove(BODY_ACTIVE_CLASS);
    unbindScope();
    if (clearOutline) {
      clearOutlines(boundScope);
      outlineTarget = null;
      pendingWrapper = null;
    }
  }

  function activateStep(scope) {
    scope = scope || getScope();
    if (!scope) return;

    document.body.classList.add(BODY_ACTIVE_CLASS);
    bindScope(scope);

    if (pendingWrapper && scope.contains(pendingWrapper)) {
      ensureStableOutline(scope);
      return;
    }

    var checked = getCheckedWrapper(scope);
    if (checked && !isDefaultBasicOnly(scope)) {
      pendingWrapper = checked;
      ensureStableOutline(scope);
      return;
    }

    applyStandardRecommendation(scope);
  }

  function scan() {
    if (confirming) return;
    var scope = getScope();
    if (!scope) {
      suspendStep();
      return;
    }
    if (!document.body.classList.contains(BODY_ACTIVE_CLASS)) {
      activateStep(scope);
      return;
    }
    ensureStableOutline(scope);
  }

  function scheduleScan() {
    if (confirming) return;
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  function scheduleInitialScan() {
    scan();
    scheduleOutlineSync();
  }

  document.addEventListener('click', onContinueClick, true);

  [
    'LensAdvizor:lensOptions:rendered',
    'LensAdvizor:lens:rendered',
    'LensAdvizor:selectLensModal:open',
    'LensAdvizor:prescriptionTypes:rendered',
    'ciw-la-sunglasses-lens-selection:confirmed',
    'ciw-la-sunglasses-package:revealed'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleInitialScan);
  });

  document.addEventListener('ciw-la-lens-package:scan-now', function () {
    if (confirming) return;
    scheduleOutlineSync();
  });

  document.addEventListener('click', function (event) {
    var back = event.target.closest && event.target.closest('.ciw-la-gusa-back-btn');
    if (!back) return;
    window.setTimeout(function () {
      if (confirming) return;
      if (!getScope()) return;
      scheduleOutlineSync();
    }, 180);
  }, true);

  document.addEventListener('DOMContentLoaded', scheduleInitialScan);
  document.addEventListener('LensAdvizor:selectLensModal:close', function () {
    deactivateStep(true);
  });

  window.ciwLaProgressivePackageContinue.suspend = suspendStep;
  window.ciwLaProgressivePackageContinue.clearOutlines = clearOutlines;
})();
